import 'intersection-observer';

import { InfinityTable } from './InfinityTable';

export { InfinityTable };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSTableInfinity/table/index.tsx